import { motion } from "framer-motion";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { faqs } from "@/config/site";

export default function FAQ() {
  return (
    <section
      id="faq"
      data-testid="faq-section"
      className="relative py-28 md:py-36 overflow-hidden"
    >
      <div className="vs-container relative z-10">
        <div className="grid lg:grid-cols-12 gap-12 lg:gap-20">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
            className="lg:col-span-4"
          >
            <div className="flex items-center gap-3">
              <span className="h-px w-10 bg-[#d4af37]" />
              <span className="text-overline">Frequently asked</span>
            </div>
            <h2 className="mt-5 font-serif-display text-4xl md:text-5xl text-white tracking-tight leading-[1.05]">
              Answers before
              <br />
              you <span className="italic vs-gold-text">ask.</span>
            </h2>
            <p className="mt-6 text-white/65 font-body leading-relaxed max-w-sm">
              Ten of the most common questions from owners considering a Virtual CFO
              engagement.
            </p>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8, delay: 0.15 }}
            className="lg:col-span-8"
            data-testid="faq-list"
          >
            <Accordion type="single" collapsible className="w-full">
              {faqs.map((f, i) => (
                <AccordionItem
                  key={i}
                  value={`item-${i}`}
                  className="border-b border-white/10"
                  data-testid={`faq-item-${i}`}
                >
                  <AccordionTrigger
                    className="text-left py-6 hover:no-underline group"
                    data-testid={`faq-trigger-${i}`}
                  >
                    <div className="flex items-start gap-5 pr-4">
                      <span className="font-mono-accent text-xs text-[#d4af37] mt-1 tracking-widest">
                        {String(i + 1).padStart(2, "0")}
                      </span>
                      <span className="font-serif-display text-lg md:text-2xl text-white group-hover:text-[#d4af37]/95 transition-colors leading-snug">
                        {f.q}
                      </span>
                    </div>
                  </AccordionTrigger>
                  <AccordionContent
                    data-testid={`faq-content-${i}`}
                    className="pl-12 pb-6 text-white/65 font-body text-[15px] leading-relaxed max-w-2xl"
                  >
                    {f.a}
                  </AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </motion.div>
        </div>
      </div>
    </section>
  );
}
